import styled from 'styled-components';

export const Container = styled.section`
  flex-direction: column;
  align-items: center;

  width: calc(100% - 28px);

  background-color: ${({ theme }) => theme.palette.mono.main};
  margin: 0 14px;

  @media (max-width: ${({ theme }) => `${theme.screensSize.mobile}px`}) {
    align-items: flex-start;
  }
`;

export const Column = styled.div`
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

export const Row = styled.div`
  justify-content: space-between;
  align-items: flex-end;

  width: 100%;

  max-width: 650px;

  flex-wrap: wrap;
`;
